import { render, staticRenderFns } from "./AllowedOutgoingDomainsModal.vue?vue&type=template&id=4f829067&"
import script from "./AllowedOutgoingDomainsModal.vue?vue&type=script&lang=js&"
export * from "./AllowedOutgoingDomainsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports